import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Cookies, CookieService } from "src/app/services/cookie.service";

@Injectable({
  providedIn: "root",
})
export class DevService {
  public _kronAgreementsToggleSubject$: BehaviorSubject<boolean>;

  public kronAgreementsToggle$;

  constructor(private readonly cookieService: CookieService) {
    const initialValue = this.cookieService.getCookie(Cookies.KronAgreementsShown) === "true";
    this._kronAgreementsToggleSubject$ = new BehaviorSubject<boolean>(initialValue);
    this.kronAgreementsToggle$ = this._kronAgreementsToggleSubject$.asObservable();
  }

  public toggleKronAgreements(): void {
    const newValue = !this._kronAgreementsToggleSubject$.value;
    this.setKronAgreementsShown(newValue);
    this._kronAgreementsToggleSubject$.next(newValue);
  }

  private setKronAgreementsShown(value: boolean): void {
    const tenHoursInSeconds = 10 * 60 * 60;
    this.cookieService.setCookie(Cookies.KronAgreementsShown, value.toString(), tenHoursInSeconds);
  }
}
